<template>
  <el-dialog title="生产套码"
    :visible.sync="visible"
    width="450px"
    @close='handleClose'
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form :model="produceInfo"
      v-loading="loading"
      :rules="rules"
      ref="ruleForm"
      label-width="120px">
      <el-form-item label="标签类型:"
        prop="tagType">
        <vendor-label-select style="width:220px"
          v-model="produceInfo.tagType"
          :exclude="[1,5]"
          :option="{vendorId: produceInfo.refVendorId}" />
        <!-- <el-select v-model="produceInfo.tagType"
          placeholder="请选择标签类型:">
          <el-option v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="生产套数:"
        prop="setCount">
        <el-input-number v-model="produceInfo.setCount"
          style="width:220px"
          :controls="false"
          :min="1"
          :max="200000"
          @blur="handleBlur"
          @focus="handleFocus"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item label="包装规格:"
        prop="corratio">
        <el-input-number v-model="produceInfo.corratio"
          style="width:220px"
          :controls="false"
          :min="1"
          :max="10000"
          @blur="handleBlur1"
          @focus="handleFocus1"
          :precision="0">
        </el-input-number>个/套
      </el-form-item>
      <el-form-item label="装箱规格:"
        prop="boxCorratio">
        <el-input-number v-model="produceInfo.boxCorratio"
          style="width:220px"
          :controls="false"
          :min="1"
          :max="10000"
          :precision="0">
        </el-input-number>套/箱
      </el-form-item>
      <el-form-item label="套码起止序号:">
        <span v-if="tagRange.beginTagNo">{{tagRange.beginSetNo | tagCount() }} - {{tagRange.endSetNo | tagCount() }}</span>
      </el-form-item>
      <el-form-item label="标签起止序号:">
        <span v-if="tagRange.beginTagNo">{{tagRange.beginTagNo | tagCount() }} - {{tagRange.endTagNo | tagCount() }}</span>
      </el-form-item>
    </el-form>
    <span slot="footer"
      class="dialog-footer">
      <el-button @click="toggleModal(false)"
        :loading="loading">取 消</el-button>
      <el-button type="primary"
        :disabled="disabled || disabled1"
        @click="addsetsegment"
        :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import VendorLabelSelect from './vendor-label-select.vue'
import Data from './index'
// let t
export default {
  name: 'set-produce-modal',
  components: { VendorLabelSelect },
  props: {
    fetch: {
      type: Function,
      required: true
    },
    fetchAll: {
      type: Function
    }
  },
  data () {
    return {
      loading: false,
      options: Data.tags,
      visible: false,
      produceInfo: {
        tagType: null,
        setCount: 1,
        corratio: 2,
        refVendorId: null
      },
      tagRange: {},
      disabled: false,
      disabled1: false,
      rules: {
        tagType: [{ required: true, message: '请选择标签类型', trigger: 'change' }],
        setCount: [{ required: true, message: '请输入生产套数', trigger: 'blur' }],
        corratio: [{ required: true, message: '请输入包装规格', trigger: 'blur' }]
      }
    }
  },
  watch: {
    produceInfo: {
      handler (val, oldVal) {
        if (val.tagType && val.setCount && val.corratio) {
          // clearTimeout(t)
          // t = setTimeout(() => {
          //   this.getnextsetsegmentinfo()
          // }, 1000)

          this.getnextsetsegmentinfo()
        }
      },
      deep: true
    }
  },
  methods: {
    init (options) {
      this.produceInfo.refVendorId = options.vendorId
      this.vendorName = options.vendorName
      this.toggleModal(true)
    },
    toggleModal (visible) {
      this.visible = visible
    },
    handleBlur () {
      setTimeout(() => {
        this.disabled = false
      }, 1000)
    },
    handleFocus () {
      this.disabled = true
    },
    handleBlur1 () {
      setTimeout(() => {
        this.disabled1 = false
      }, 1000)
    },
    handleFocus1 () {
      this.disabled1 = true
    },
    handleClose () {
      this.$refs.ruleForm.resetFields()
      this.tagRange = {}
      this.produceInfo = {
        tagType: null,
        setCount: 1,
        corratio: 2,
        refVendorId: null
      }
    },
    addsetsegment () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('label/addsetsegment', {
            payload: {
              ...this.produceInfo,
              isPreassign: 1
            },
            success: (res) => {
              this.loading = false
              this.toggleModal(false)
              this.fetch()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    getnextsetsegmentinfo () {
      if (!this.produceInfo.tagType || !this.produceInfo.setCount || !this.produceInfo.corratio) {
        return
      }
      this.loading = true
      this.$store.dispatch('label/getnextsetsegmentinfo', {
        payload: {
          tagType: this.produceInfo.tagType,
          setCount: this.produceInfo.setCount,
          corratio: this.produceInfo.corratio,
          vendorId: this.produceInfo.refVendorId
        },
        success: (res) => {
          this.loading = false
          this.tagRange = res.data
        },
        fail: () => {
          this.loading = false
          this.tagRange = {}
        }
      })
    }
  }
}
</script>
